var _g, _rect, _rect2, _rect3, _rect4, _g2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _g3, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _g4, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAccountDataLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 222,
    viewBox: "0 0 446 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2058_94047)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 9,
    width: 322.165,
    height: 199.602,
    rx: 10,
    fill: "url(#paint0_linear_2058_94047)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.606,
    y: 9.60604,
    width: 320.952,
    height: 198.39,
    rx: 9.39396,
    stroke: "url(#paint1_linear_2058_94047)",
    strokeWidth: 1.21208
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.6719,
    y: 20.6719,
    width: 60.6977,
    height: 176.257,
    rx: 5,
    fill: "#F5F5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6758,
    y: 40.5156,
    width: 46.6905,
    height: 5.83632,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6758,
    y: 63.8613,
    width: 46.6905,
    height: 5.83632,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6758,
    y: 52.1875,
    width: 46.6905,
    height: 5.83632,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2058_94047)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 42.0625,
    width: 240.041,
    height: 66.9587,
    rx: 5,
    transform: "rotate(-7.91665 180 42.0625)",
    fill: "url(#paint2_linear_2058_94047)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.684,
    y: 42.5793,
    width: 238.829,
    height: 65.7466,
    rx: 4.39396,
    transform: "rotate(-7.91665 180.684 42.5793)",
    stroke: "#9DA2D1",
    strokeWidth: 1.21208,
    strokeDasharray: "5 5"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 194.949,
    y: 57.8398,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 194.949 57.8398)",
    fill: "#D5D8F5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 198.43,
    y: 82.8672,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 198.43 82.8672)",
    fill: "#D5D8F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 196.691,
    y: 70.3535,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 196.691 70.3535)",
    fill: "#D5D8F5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 271.281,
    y: 47.2246,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 271.281 47.2246)",
    fill: "#D5D8F5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 274.758,
    y: 72.252,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 274.758 72.252)",
    fill: "#D5D8F5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 59.7383,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 273.02 59.7383)",
    fill: "#D5D8F5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 347.609,
    y: 36.6113,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 347.609 36.6113)",
    fill: "#D5D8F5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 351.094,
    y: 61.6387,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 351.094 61.6387)",
    fill: "#D5D8F5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 349.352,
    y: 49.125,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 349.352 49.125)",
    fill: "#D5D8F5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2058_94047)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 118,
    width: 240.041,
    height: 66.9587,
    rx: 5,
    fill: "url(#paint3_linear_2058_94047)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.606,
    y: 118.606,
    width: 238.829,
    height: 65.7466,
    rx: 4.39396,
    stroke: "#9DA2D1",
    strokeWidth: 1.21208,
    strokeDasharray: "5 5"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 207.633,
    y: 135.686,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 207.633,
    y: 160.955,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 207.633,
    y: 148.32,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 284.699,
    y: 135.686,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 284.699,
    y: 160.955,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 284.699,
    y: 148.32,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 361.766,
    y: 135.686,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 361.766,
    y: 160.955,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 361.766,
    y: 148.32,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#D5D8F5"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2058_94047)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 113.254,
    width: 66.4941,
    height: 66.4941,
    rx: 5,
    transform: "rotate(-8 12 113.254)",
    fill: "url(#paint4_linear_2058_94047)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6845,
    y: 113.77,
    width: 65.2821,
    height: 65.2821,
    rx: 4.39396,
    transform: "rotate(-8 12.6845 113.77)",
    stroke: "#008AFF",
    strokeWidth: 1.21208,
    strokeDasharray: "5 5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8042 128.705C48.7132 128.057 48.1146 127.606 47.4672 127.697C46.8198 127.788 46.3687 128.387 46.4597 129.034L48.0523 140.366L36.7206 141.958C36.0732 142.049 35.6221 142.648 35.7131 143.295C35.8041 143.943 36.4027 144.394 37.0501 144.303L48.3818 142.71L49.9743 154.042C50.0653 154.689 50.6639 155.14 51.3113 155.049C51.9587 154.958 52.4098 154.36 52.3188 153.712L50.7262 142.381L62.0579 140.788C62.7054 140.697 63.1564 140.099 63.0654 139.451C62.9744 138.804 62.3759 138.353 61.7284 138.444L50.3968 140.036L48.8042 128.705Z",
    fill: "#008AFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2058_94047",
    x: 38,
    y: 0,
    width: 344.164,
    height: 221.602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2058_94047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2058_94047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2058_94047",
    x: 168.641,
    y: 0.640625,
    width: 267.695,
    height: 120.102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2058_94047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2058_94047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2058_94047",
    x: 183,
    y: 109,
    width: 262.039,
    height: 88.959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2058_94047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2058_94047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2058_94047",
    x: 0.646484,
    y: 95.6465,
    width: 95.8086,
    height: 95.8086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2058_94047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2058_94047",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2058_94047",
    x1: 50,
    y1: 191.563,
    x2: 379.377,
    y2: 80.0164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2058_94047",
    x1: 39.9688,
    y1: 181.641,
    x2: 346.66,
    y2: 19.4735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2058_94047",
    x1: 180,
    y1: 103.305,
    x2: 354.711,
    y2: -28.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2058_94047",
    x1: 195,
    y1: 179.243,
    x2: 369.711,
    y2: 47.8267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2058_94047",
    x1: 12,
    y1: 174.072,
    x2: 84.5842,
    y2: 158.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccountDataLight);
export default __webpack_public_path__ + "static/media/noAccountDataLight.7cc070bb87f216d37d65c0aca42df61a.svg";
export { ForwardRef as ReactComponent };